var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgContactPhone = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 20C0.5 9.23045 9.23045 0.5 20 0.5H28C38.7696 0.5 47.5 9.23045 47.5 20V28C47.5 38.7696 38.7696 47.5 28 47.5H20C9.23045 47.5 0.5 38.7696 0.5 28V20Z",
    fill: "white",
    stroke: "#DDE2EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4483 14.3424L20.4795 14.0127C21.4474 13.7042 22.4795 14.2034 22.8945 15.179L23.7177 17.1225C24.0761 17.9687 23.8777 18.9644 23.2251 19.5835L21.41 21.3066C21.5212 22.3378 21.8681 23.3527 22.4489 24.3512C23.0007 25.3174 23.7407 26.1631 24.6252 26.8381L26.8054 26.1098C27.6325 25.8347 28.5324 26.1519 29.0384 26.8966L30.22 28.6312C30.8094 29.4975 30.7039 30.6916 29.9727 31.4257L29.1888 32.2124C28.4087 32.9954 27.2942 33.28 26.264 32.958C23.8308 32.199 21.594 29.946 19.5528 26.1989C17.5087 22.4461 16.787 19.2606 17.3889 16.6462C17.6419 15.5461 18.4248 14.6692 19.4483 14.3424Z",
    fill: "#03002F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgContactPhone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/contactPhone.32dbea0f8d5f014a1d92c36b8963fab3.svg";